__turbopack_context__.v({
  "ChartContainer": "oAIE9G_ChartContainer",
  "ChartHeader": "oAIE9G_ChartHeader",
  "ChartTitle": "oAIE9G_ChartTitle",
  "ChartTitle--Large": "oAIE9G_ChartTitle--Large",
  "DynamicPropertyContainer": "oAIE9G_DynamicPropertyContainer",
  "Error": "oAIE9G_Error",
  "ErrorWrapper": "oAIE9G_ErrorWrapper",
  "LoaderContainer": "oAIE9G_LoaderContainer",
  "Root": "oAIE9G_Root",
  "skeleton-loading": "oAIE9G_skeleton-loading",
});
